import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Template } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const TemplatesTableDescriptionCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<Template>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={template.description} />
    </TableSimpleCell>
  );
};

export default TemplatesTableDescriptionCell;
